module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0712.cab87031.jpg";